<div fxFlex fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.gt-sm="start center">
  <h3 class="u-heading-3">
    {{'The {name} Family Account' | pghDictionary : { name: contractLastName } }}
  </h3>
</div>
